import { ComponentProps } from "react";

import { useNavigation } from "@remix-run/react";

import { Button } from "../ui";

export default function SubmitButton({ disabled, children, ...props }: ComponentProps<"button">) {
    const navigation = useNavigation();

    const isIdle = navigation.state === "idle";

    return (
        <Button type="submit" disabled={disabled || !isIdle} variant={isIdle ? "default" : "disabled"} {...props}>
            {isIdle ? children : "Submitting..."}
        </Button>
    );
}
